import { render } from "./HighlightBox.vue?vue&type=template&id=62381b22&scoped=true"
import script from "./HighlightBox.vue?vue&type=script&lang=js"
export * from "./HighlightBox.vue?vue&type=script&lang=js"

import "./HighlightBox.css?vue&type=style&index=0&id=62381b22&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62381b22"]])

export default __exports__